export default {
  BusinessStockMovementLang: {
    PO_INBOUND: 'PO INBOUND',
    ORDER_OUTBOUND: 'ORDER OUTBOUND',
    CUSTOMER_RETURNS: 'CUSTOMER RETURNS',
    STOCK_ADJUSTMENTS: 'STOCK ADJUSTMENTS',
    USER : 'USER ID',
    DATE : 'DATE',
    SKU : 'SKU IDENTITY',
    TYPE : 'MOVE TYPE',
    QTY : 'QTY CHANGE',
    REFERENCE  : 'REFERENCE NO',
    type1 : 'PO INBOUND',
    type2 : 'ORDER OUTBOUND',
    type3 : 'RETURN',
    type4 : 'ADJUSTMENT',
  }
};
